module.exports = {
  random: require('./random'),
  roundRobin: require('./round_robin')
};